'use client';

import { Badge, Button, Card, Group, Image, Text } from '@mantine/core';
import { closeAllModals, type ContextModalProps } from '@mantine/modals';
import { assetPrefix } from '@/lib/constants';

export type WarningOverCancelledOrderModalProps = ContextModalProps<{
  numCancelledOrderToday: number;
}>;

export function WarningOverCancelledOrderModal({
  innerProps: { numCancelledOrderToday },
}: WarningOverCancelledOrderModalProps) {
  // Will get warningMessage from remote config cancel_order_warning_message${suffix}
  const warningMessage =
    'Khách hàng với tỉ lệ huỷ cao sẽ không được ưu tiên nhận đơn hàng';

  const keepOrder = () => {
    closeAllModals();
  };

  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder>
      <Card.Section>
        <Image
          src={`${assetPrefix}/static/images/cancel-order/over-cancelled-today.webp`}
          height={160}
          alt="Warning Over Cancelled Order"
        />
      </Card.Section>

      <Group justify="space-between" mt="md" mb="xs">
        <Text fw={500}>Opps, Bạn đã huỷ đơn hàng quá nhiều</Text>
        <Badge color="red">{numCancelledOrderToday} đơn hủy</Badge>
      </Group>

      <Text size="sm">{warningMessage}</Text>

      <Button fullWidth mt="md" radius="md" size="md" onClick={keepOrder}>
        Giữ đơn hàng
      </Button>
    </Card>
  );
}
